<div class="line-chart-container" id="chart"  #chartContainer style="width : 100%; height: 100%;" ></div>
